module.exports = __webpack_public_path__ + "static/media/Pump_station_dublin.22c1d043.jpg";